import clsx from 'clsx';
import { CSSProperties, PropsWithChildren } from 'react';
import { CSS_VAR_COLOR } from '../../constants/css';
import { convertBemToCamel } from '../../helpers';
import styles from './Badge.module.scss';

export type BadgeProps = PropsWithChildren<{
  size?: 'l';
  corner?: 'left' | 'right' | 'all';
  color?: 'white' | 'yellow';
  className?: string;
}>;

export const Badge = ({
  children,
  size,
  corner = 'left',
  color = 'yellow',
  className,
}: BadgeProps) => {
  const classes = clsx(
    styles.base,
    className,
    styles[convertBemToCamel(`corner--${corner}`)],
    size && styles[convertBemToCamel(`size--${size}`)],
    color && styles[convertBemToCamel(`color--${color}`)]
  );

  const style = {
    [CSS_VAR_COLOR]: color,
  } as CSSProperties;

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};
